export const getAppState = state => state.appData;

export const appIsLoaded = state => state.appData.isLoaded;
export const appIsLoading = state => state.appData.isLoading;

export const getSiteLang = state => state.appData.siteLang;